export default class Messages {

	constructor(name) {
		window[name] = this.data()
	}


	data() {
		return {
			messages: [],
			newMessage: null,
			toastDisplay: true,
			toastMessage: 'Bezig met laden...',
			subplanUid: window.subplan,
			loading: false,
			HasAUserSeenChat: false,
			HasContactSeenChat: false,
			ChatIntro: '',

			initPuscher(){
				var vm = this;
				if( ! window.channel ) return 

					window.channel.bind('ChatCreated', function(data) {
						vm.toastMessage = "Nieuwe bericht";
						vm.toastDisplay = true;
						vm.messages.push(data);
						vm.scrollToBottom();
					});
			},
 
			sendMessage(){
				var vm = this;
				var message = vm.newMessage
				vm.newMessage = ''
				vm.loading = true
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.showModal = false
						vm.loading = false
						
						vm.HasAUserSeenChat = false;
						if( ! window.channel ){
							window.location.reload()
						} 
					}
				}
				xhttp.open('post', '/woonmens/api/'+ this.subplanUid +'/messages', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify({msg: message}));
			},

			scrollToBottom(vm = this){
				setTimeout(function(){
					var objDiv = document.getElementById("scroll-container");
					objDiv.scrollTop = objDiv.scrollHeight;
				},200)
			},

			init(vm = this) {
				vm.initPuscher();
				var xhttp = new XMLHttpRequest();
				vm.initialised = true
				xhttp.onreadystatechange = function() {
					

					if (this.readyState == 4 && this.status == 200) {
						vm.toastDisplay = false
						vm.HasAUserSeenChat = JSON.parse(this.responseText).HasAUserSeenChat;
						vm.messages = JSON.parse(this.responseText).messages;
						vm.scrollToBottom()
					}
				}
				xhttp.open('get', '/woonmens/api/'+ vm.subplanUid +'/messages/', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				setTimeout(function(){
					xhttp.send();
				},2000)
			},
			shouldSendMessage(event) {
				if (event.keyCode == 13 && !event.shiftKey) {
					event.target.disabled = true;
					this.sendMessage()
					setTimeout(
						function() {
							event.target.disabled = false
						}, 1000);
				}
			},
			formatMessage(message){
				message = this.nl2br(message)
				message = this.makeAnchorTag(message);
				return message
			},
			makeAnchorTag(message){
				return message;
    			var isAlreadyAnchor =  /^\<a.*\>.*\<\/a\>/i.test(message);
    			if(!isAlreadyAnchor){
    				message = message.replace(/(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z09+&@#\/%=~_|])/img, '<a class="text-blue-500" target="_blank" href="$1">$1</a>');
    			}
    			return message;
			},
			nl2br (message, replaceMode, isXhtml) {
 			 	var breakTag = (isXhtml) ? '<br />' : '<br>';
  				var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
  				return (message + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
			}    
		}
	}
}